import { CreateCoachBooking, CreateCoachBookingServer } from '../store/types';

//transformCreateCoachBookingBody
export const transformCtCoachBkBody = (body: CreateCoachBooking): CreateCoachBookingServer => ({
  'start_time': body.startTime,
  'end_time': body.endTime,
  'coach_id': body.coachId,
  ...(body.repeatUntil !== undefined && { 'repeat_until': body.repeatUntil }),
});
